import type * as React from 'react';
import { createContext, useContext } from 'react';

// Refs to layout-relevant page elements that consumers (e.g. TwoPanelConversationalDiscoveryLayout)
// need to measure but don't own. The provider lives at ConsumerHeaderFooterWrapper, which is the
// common ancestor of all producers and consumers. The same `pageHeaderRef` object is also
// exposed via composable-page-header's PageHeaderRefContext so GlobalPageHeaderContainer can
// attach to it without importing from this bundle.
export type PageRefsContextType = {
  pageHeaderRef: React.MutableRefObject<HTMLDivElement | null>;
  fixedPageNavRef: React.MutableRefObject<HTMLDivElement | null>;
};

const PageRefsContext = createContext<PageRefsContextType | undefined>(undefined);

export const usePageRefs = () => {
  return useContext(PageRefsContext);
};

export default PageRefsContext;
